module.exports = __webpack_public_path__ + "img/Gallery_2_32.bcaa0d1c.jpeg";